import { render, staticRenderFns } from "./kuranSwiperItem.vue?vue&type=template&id=e3f5f67a"
import script from "./kuranSwiperItem.vue?vue&type=script&lang=js"
export * from "./kuranSwiperItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports